import { gql } from "@apollo/client";

export const upsertKeyholdingSiteBillingMutation = gql`
mutation($input: KeyHoldingSiteBillingInput!){
  upsertKeyholdingSiteBilling(input: $input) {
    message
    response
  }
}
`;


export const DeleteKeyholdingSiteBillingMutation = gql`
mutation DeleteKeyholdingSiteBilling($planId: String!) {
  deleteKeyholdingSiteBilling(planId: $planId) {
    
    message
  }
}
`;


export const DownloadKeyholdingTemplateMutation = gql`
mutation DownloadKeyholdingTemplate {
  downloadKeyholdingTemplate {
    filename
    contentType
    base64Data
  }
}
`;
